<div
  class="king-user-avatar"
  [class.king]="!isChallenger()"
  [class.challenger]="isChallenger()"
  [class.size-1]="size() === 1"
  [class.size-2]="size() === 2"
  [style.cursor]="kingUser() === null ? 'default' : 'pointer'"
  (click)="
    kingUser() ? contextMenuService.open($event, { user: kingUser()! }) : null
  "
>
  <img
    class="king-user-avatar__avatar"
    [src]="kingUser()?.avatar ?? 'assets/icons/shared/profile.svg'"
    [alt]="kingUser()?.name ?? 'placeholder'"
    [class.placeholder]="kingUser() === null"
  />
  <div class="king-user-avatar__hexagon">
    <div class="king-user-avatar__hexagon--background"></div>
    <svg-icon
      class="king-user-avatar__hexagon--icon flex items-center justify-center s-24"
      [src]="
        isChallenger()
          ? 'assets/icons/king/sword.svg'
          : 'assets/icons/games/king.svg'
      "
    ></svg-icon>
  </div>
  @if (!isChallenger()) {
  <img class="king-user-avatar__crown" src="assets/images/king/crown.png" />
  }
</div>
